module.exports = __webpack_public_path__ + "static/img/join-banner.6b9462eb.png";